// import { useState } from 'react'

import styles from './KeynoteRecording.module.scss'

// import { ReactComponent as YoutubeIcon } from 'assets/svg/social/youtube.svg'

const RecordingCard = ({ item }: any) => {
  // const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={styles.card}>
      <iframe
        width='560'
        height='315'
        src={`${item.videoUrl}?autoplay=1`}
        title={`${item.name} | AWS Community Day Armenia 2024 | Special Guest Speaker`}
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        referrerPolicy='strict-origin-when-cross-origin'
        allowFullScreen
      />
      {/* {!isOpen && (
        <div
          className={styles.card__banner}
          onClick={() => {
            setIsOpen(true)
          }}
        >
          <img src={item.banner} alt='youtube banner' />
          <YoutubeIcon />
        </div>
      )} */}
    </div>
  )
}

export default RecordingCard
